export function isValidDate(date: string) {
    return !!date && !isNaN(new Date(date).getTime());
}
